import { render, staticRenderFns } from "./ManualSystem.vue?vue&type=template&id=efeb751c&scoped=true"
import script from "./ManualSystem.vue?vue&type=script&lang=js"
export * from "./ManualSystem.vue?vue&type=script&lang=js"
import style0 from "./ManualSystem.vue?vue&type=style&index=0&id=efeb751c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efeb751c",
  null
  
)

export default component.exports